import { createComponent } from '../lib';
import { VmCurrentTime, VmTime } from '@vime/core';
import { define } from '../lib';
define('vm-current-time', VmCurrentTime);
define('vm-time', VmTime);
;
export default createComponent('vm-current-time', new Set(['currentTime', 'i18n', 'alwaysShowHours']));
